import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccess } from "@/lib/rbac";
import { GlassCard } from "@/components/ui/GlassCard";
import { Skeleton } from "@/components/ui/Skeleton";

export const ProtectedRoute = ({ children, moduleKey }) => {
    const { isAuthenticated, bootstrapping, user } = useAuth();
    const location = useLocation();

    if (bootstrapping) {
        return (
            <div className="min-h-screen flex items-center justify-center p-8">
                <GlassCard padding="p-8">
                    <Skeleton width="220px" height="20px" />
                    <div className="mt-3">
                        <Skeleton width="280px" height="14px" />
                    </div>
                </GlassCard>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (moduleKey && !canAccess(moduleKey, user?.role)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};
